module.exports = __webpack_public_path__ + "static/media/Doctor_illustration.826042e3.svg";